import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormClientComponent } from './form-client/form-client.component';

const routes: Routes = [
  {
    path:'dashboard',
    loadChildren:()=>import('./dashboard/dashboard.module').then(m=>m.DashboardModule)
  },
  {
    path:'',
    loadChildren:()=>import('./auth/auth.module').then(m=>m.AuthModule)
  },
  {
    path:'benchmarking',
    loadChildren:()=>import('./benchmarking/benchmarking.module').then(m=>m.BenchmarkingModule)
  },
  {
    path:'comercial',
    loadChildren:()=>import('./comercial/comercial.module').then(m=>m.ComercialModule)
  },
  {
    path:'asamblea',
    loadChildren:()=>import('./assembly/assembly.module').then(m=>m.AssemblyModule)
  },
  {
    path:'ruleta',
    loadChildren:()=>import('./roulette/roulette.module').then(m=>m.RouletteModule)
  },
  {
    path:'fpqrs',
    loadChildren:()=>import('./viewfpqrs/viewfpqrs.module').then(m=>m.ViewfpqrsModule)
  },
  {
    path: 'form-client',
    component: FormClientComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
